module.exports = __webpack_public_path__ + "fonts/opensans-bolditalic.dcd27842.ttf";